// src/locales/en_US.ts
import type { LocaleData } from "../core/types";

export const en_US: LocaleData = {
  notEmpty: { default: "Please enter a value" },
  email: { default: "Please enter a valid email address" },
  creditCard: { default: "Please enter a valid credit card number" },
  date: { default: "Please enter a valid date" },
  digits: { default: "Please enter only digits" },
  integer: { default: "Please enter a valid integer" },
  numeric: { default: "Please enter a valid number" },
  regexp: { default: "Please enter a value matching the required pattern" },
  uri: { default: "Please enter a valid URL" },
  identical: { default: "Please enter the same value" },
  different: { default: "Please enter a different value" },
  between: { default: "Please enter a value between the minimum and maximum" },
  greaterThan: { default: "Please enter a value greater than or equal to the minimum" },
  lessThan: { default: "Please enter a value less than or equal to the maximum" },
  stringLength: { default: "Please enter a value with a valid length" },
  stringCase: { default: "Please enter a value with the correct case" },
  choice: { default: "Please choose the correct number of options" },
  file: { default: "Please select a valid file" },
  callback: { default: "Please enter a valid value" },
  promise: { default: "Please enter a valid value" },
  remote: { default: "Please enter a valid value" },
  ip: { default: "Please enter a valid IP address" },
  base64: { default: "Please enter a valid Base64 encoded string" },
  hex: { default: "Please enter a valid hexadecimal number" },
  mac: { default: "Please enter a valid MAC address" },
  bic: { default: "Please enter a valid BIC/SWIFT code" },
  uuid: { default: "Please enter a valid UUID" },
  color: { default: "Please enter a valid color" },
  step: { default: "Please enter a valid step value" },
  vin: { default: "Please enter a valid VIN" },
  ean: { default: "Please enter a valid EAN number" },
  isbn: { default: "Please enter a valid ISBN number" },
  ismn: { default: "Please enter a valid ISMN number" },
  issn: { default: "Please enter a valid ISSN number" },
  grid: { default: "Please enter a valid GRId" },
  cusip: { default: "Please enter a valid CUSIP number" },
  isin: { default: "Please enter a valid ISIN number" },
  sedol: { default: "Please enter a valid SEDOL number" },
  imei: { default: "Please enter a valid IMEI number" },
  imo: { default: "Please enter a valid IMO number" },
  meid: { default: "Please enter a valid MEID number" },
  ein: { default: "Please enter a valid EIN number" },
  rtn: { default: "Please enter a valid RTN" },
  siren: { default: "Please enter a valid SIREN number" },
  siret: { default: "Please enter a valid SIRET number" },
  iban: { default: "Please enter a valid IBAN" },
  phone: { default: "Please enter a valid phone number" },
  zipCode: { default: "Please enter a valid zip code" },
  vat: {
    default: "Please enter a valid VAT number",
    country: "Please enter a valid VAT number in %s",
  },
  id: {
    default: "Please enter a valid national identification number",
    country: "Please enter a valid national identification number in %s",
  },
};
